// jshint esversion: 8
export default (fieldName) => fieldName.replace(/^./g,
  match => match.toUpperCase()).replace(/[_]./g,
  match => match.replace(/_/g, ' ').toUpperCase())
